module.exports = __webpack_public_path__ + "img/getyourguide.20fbd921.svg";